import { type FC, type ReactNode } from 'react';
import { Button, Badge, Flex, Popover } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface FilterButtonProps {
  label?: string;
  count?: number;
  popoverContent?: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const FilterButton: FC<FilterButtonProps> = ({
  label,
  count = 0,
  popoverContent,
  open = false,
  onOpenChange,
}) => {
  const { t } = useTranslation();

  if (!popoverContent) {
    return (
      <Button
        className={styles.button}
        type="text"
        icon={
          <div className={styles['icon-wrapper']}>
            <FilterOutlined />
          </div>
        }
      >
        <Flex align="center" gap={8}>
          <span className={styles.text}>
            {label ?? t('controls.filters', 'Filters')}
          </span>
          {count > 0 && <Badge count={count} className={styles.badge} />}
        </Flex>
      </Button>
    );
  }

  return (
    <Popover
      content={popoverContent}
      trigger="click"
      open={open}
      onOpenChange={onOpenChange || (() => {})}
      align={{ offset: [0, 16] }}
      placement="bottomRight"
      className={styles.popover}
      overlayStyle={{ position: 'fixed' }}
      arrow={false}
    >
      <Button
        className={styles.button}
        type="text"
        icon={
          <div className={styles['icon-wrapper']}>
            <FilterOutlined />
          </div>
        }
      >
        <Flex align="center" gap={8}>
          <span className={styles.text}>
            {label ?? t('controls.filters', 'Filters')}
          </span>
          {count > 0 && <Badge count={count} className={styles.badge} />}
        </Flex>
      </Button>
    </Popover>
  );
};

export default FilterButton;
